module.exports = __webpack_public_path__ + "img/Head_third.304f184c.png";